<template>
    <v-dialog
        :value="cookiesAccepted && !updateExists && !trackAndTraceAccepted"
        :overlay-opacity="0.2"
        persistent
        dark
    >
        <v-card color="blue-grey darken-4">
            <v-card-title>
                Track & Trace
            </v-card-title>
            <v-card-text class="pb-2">
                Customers are reminded that they MUST complete track and trace; either
                by scanning the QR code in the
                <a
                    :href="appstoreLink"
                    target="_blank"
                    class="font-weight-bold white--text"
                >NHS COVID-19</a>
                app or by signing in the visitors book every time they visit the Club.
            </v-card-text>
            <v-card-actions class="pb-3">
                <v-spacer />
                <v-btn
                    @click="acceptTrackAndTrace"
                    color="primary"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import update from '@/mixins/update';

export default {
  name: 'PromptTrackAndTrace',

  mixins: [update],

  computed: {
    appstoreLink() {
      if (this.iOS()) {
        return 'https://apps.apple.com/gb/app/nhs-covid-19/id1520427663';
      }

      return 'https://play.google.com/store/apps/details?id=uk.nhs.covid19.production';
    },

    ...mapGetters([
      'cookiesAccepted',
      'trackAndTraceAccepted',
    ]),
  },

  methods: {
    ...mapActions([
      'acceptTrackAndTrace',
    ]),
  },
};
</script>

<style lang="scss" scoped>

</style>
